import { DropdownMenuItem } from '../design-system/DropdownMenu/Item/types'
import { isInstanceAnalyticsEnabledByWindowFeatureFlag } from '../Analytics/AnalyticsService'

export function getProductPickerMenuItems(isVoiceBuilderEnabled: boolean): DropdownMenuItem[] {
  const menuItems: DropdownMenuItem[] = [{ type: 'redirect', label: 'Dashboard', redirectTo: '/' }]

  if (isInstanceAnalyticsEnabledByWindowFeatureFlag()) {
    menuItems.push({ type: 'redirect', label: 'Analytics', redirectTo: `/analytics` })
  }

  if (isVoiceBuilderEnabled) {
    menuItems.push({ type: 'redirect', label: 'Voicebot designer', redirectTo: '/voice' })
  }

  return menuItems
}
